export const PREVIOUS_CALLID_STORAGE_KEY = 'ci-SAT';